import { apiORDS, apiAutNFe, apiAutNFSe, apiSyncNFSe, apiValidaLimitePlano } from '../shared/api-functions'
import { SysVars } from '../main'

export default {
  methods: {
    async autorizaNFSe(nf , responseCallback){
      if (nf.tpnf != 'S') {
        this.$erpToastError('A nota fiscal deve ser do tipo serviço.')
        return
      }
      if (nf.tpnf == 'S' && !SysVars.ambienteHomologacaoNFe) {
        const isValid = await apiValidaLimitePlano(this, 'nfservico')
        if (!isValid)
          return
      }

      this.$appLoading(true)
      const response = await apiAutNFSe(this, nf.codnf)
      console.log(response)
      if (response) {
          if (response.errmessages) {
              this.$erpToastError(response.errmessages[0])
              this.errmessages = {}
              this.errmessages.errmessages = response.errmessages
          } else {
              if (response.items.length > 0) {
                  if (response.items[0].stnf === '10') {
                      //EXIBE A MENSAGEM DE NF AUTORIZADA E ATUALIZA O STATUS E CHAVE DA NF NA TELA
                      this.$erpToastSuccess('Nota fiscal autorizada')
                  }
                    else {
                      nf.xmotivo = response.items[0].xmotivo
                      this.$erpToastWarning(response.items[0].xmotivo)
                  }
              }
              else {
                  //LOTE REJEITADO OU AINDA NAO PROCESSADO
                  nf.stnf = '50'  //NF REJEITADA
                  nf.xmotivo = response.message
                  this.$erpToastError(response.message)
              }
          }
      }
      if (responseCallback) {
        responseCallback(response)
      }

    },

    async sincronizaNFSe(nf , responseCallback){
      if (nf.tpnf != 'S') {
        this.$erpToastError('A nota fiscal deve ser do tipo serviço.')
        return
      }

      this.$appLoading(true)
      const response = await apiSyncNFSe(this, nf.codnf)
      console.log(response)
      if (response) {
          if (response.errmessages) {
              this.$erpToastError(response.errmessages[0])
              this.errmessages = {}
              this.errmessages.errmessages = response.errmessages
          } else {
              if (response.items.length > 0) {
                  if (response.items[0].stnf === '10') {
                      //EXIBE A MENSAGEM DE NF AUTORIZADA E ATUALIZA O STATUS E CHAVE DA NF NA TELA
                      this.$erpToastSuccess('Nota fiscal autorizada')
                  }
                    else {
                      nf.xmotivo = response.items[0].xmotivo
                      this.$erpToastWarning(response.items[0].xmotivo)
                  }
              }
              else {
                  //LOTE REJEITADO OU AINDA NAO PROCESSADO
                  nf.stnf = '50'  //NF REJEITADA
                  nf.xmotivo = response.message
                  this.$erpToastError(response.message)
              }
          }
      }
      if (responseCallback) {
        responseCallback(response)
      }

    },


    autorizaNFeSAT (nf, responseCallback) {
     this.$executaExtensaoChromeSAT(nf.codnf, 'sat', responseCallback )
    },

    async autorizaNFeA3 (nf, responseCallback) {
      if (nf.operacaonf == 'S' && nf.movest == 'S' && nf.flagestoquebaixado != 'S') {
        this.$erpToastError('Efetue a baixa do estoque para prosseguir')
        return
      }

      //validação de limite de plano
      if (!SysVars.ambienteHomologacaoNFe) {
        if (nf.coddi) {
          const isValid = await apiValidaLimitePlano(this, 'nfimportacao')
          if (!isValid)
            return
        }
        else {
          const isValid = await apiValidaLimitePlano(this, 'nfe')
          if (!isValid)
            return
        }
      }

      this.$appLoading(true)
      // const baixa = await this.baixaEstoqueNF(nf)
      // if (!baixa)
      //   return
      this.$executaExtensaoChromeA3(nf.codnf, 'nfe', responseCallback)
    },

    // async baixaEstoqueNF (nf) {
    //   let url = '/estoque/nfsaida/baixarestoque/' + nf.codnf
    //   const response = await apiORDSpost(this.$store, url, null, 'put')
    //   //erro 400 é retornado se o estoque não for baixado
    //   return true
    // },

    async autorizaNFeA1 (nf, responseCallback) {
      if (nf.operacaonf == 'S' && nf.movest == 'S' && nf.flagestoquebaixado != 'S') {
        this.$erpToastError('Efetue a baixa do estoque para prosseguir')
        return
      }

      //validação de limite de plano
      if (!SysVars.ambienteHomologacaoNFe) {
        if (nf.coddi) {
          const isValid = await apiValidaLimitePlano(this, 'nfimportacao')
          if (!isValid)
            return
        }
        if (nf.esp=='65') {
          const isValid = await apiValidaLimitePlano(this, 'nfce')
          if (!isValid)
            return
        }
        else {
          const isValid = await apiValidaLimitePlano(this, 'nfe')
          if (!isValid)
            return
        }
      }

      this.$appLoading(true)
      const response = await apiAutNFe(this, nf.codfil, nf.codnf)
      if (response.data) {
          if (response.data.errmessages) {
              this.$erpToastError(response.data.errmessages[0])
              this.errmessages = {}
              this.errmessages.errmessages = response.data.errmessages
          } else {
              if (response.data.nf.length > 0) {
                  if (response.data.nf[0].cstat === '100') {
                      //EXIBE A MENSAGEM DE NF AUTORIZADA E ATUALIZA O STATUS E CHAVE DA NF NA TELA
                      this.$erpToastSuccess('Nota fiscal autorizada')
                      nf.stnf = '10'
                      nf.chave = response.data.nf[0].chave
                      nf.xmotivo = ''
                  }
                    else {
                      if ((response.data.nf[0].cstat === '302') || (response.data.cstat === '302'))
                        nf.stnf = '92'
                      else
                        nf.stnf = '50'
                      let motivo = response.data.nf[0].xmotivo || response.data.xmotivo
                      nf.xmotivo = motivo
                      this.$erpToastError(motivo)
                  }
              }
              else {
                  //LOTE REJEITADO OU AINDA NAO PROCESSADO
                  nf.stnf = '50'  //NF REJEITADA
                  nf.xmotivo = response.data.xmotivo
                  this.$erpToastError(response.data.xmotivo)
              }
          }
      }
      if (responseCallback) {
        responseCallback(response)
      }
    },

    ambienteHomologacaoNFe () {
      apiORDS(this.$store.getters.urlOrds + 'cg/ambientenfe', null, true).then((result) => {
        if (result)
          SysVars.ambienteHomologacaoNFe = result.homologacao
        else
          SysVars.ambienteHomologacaoNFe = null
      })

    },


  }
}





// WEBPACK FOOTER //
// ./src/api/api-nfe.js